<template>
    <div class="carousel">
        <h2 class="title" v-text="'Filhos'"></h2>
        <div class="carousel-container">
            <div class="carousel-item" v-for="(cItem, cKey) in carrouselItens" :key="cKey" @click="emitEvent(cItem)" :class="{'add-user' : cItem.IDSITCONSUMI === 'A'}">
                <div class="carousel-item-dependant" v-if="showDependent(cItem)">
                    <template v-for="(fItem, fKey) in fieldMap.filter(f => f != 'action')" :key="fKey">
                        <i v-if="fItem?.toLowerCase() == 'icon'" :class="`fas fa-${cItem[fItem]}`"></i>
                        <span v-else-if="fItem?.toLowerCase() == 'balance'" v-text="cItem[fItem]"></span>
                        <h3 v-else v-text="fixLength(cItem[fItem])"></h3>
                    </template>
                </div>
                <div v-else-if="cItem && cItem.IDSITCONSUMI === 'A'" class="add-user">
                    <i class="fas fa-plus"></i>
                </div>
                <div v-else class="blocked">
                    <i class="fas fa-dollar-sign"></i>
                    <h3><b>Bloqueado</b></h3>
                    <h3 v-text="fixLength(cItem.NMCONSUMIDOR)"></h3>
                </div>
            </div>
        </div>
    </div>
</template>
<script>

export default {
    name: 'CarouselComponent',
    props: ['carrouselItens', 'fieldMap'],
    data () {
        return {
        }
    },
    methods: {
        fixLength: function (text) {
            return text.length > 28 ? text.substr(0, 25) + '...' : text
        },
        emitEvent: function (cItem) {
            this.$emit('componentEvent', cItem)
        },
        showDependent: function (dependent) {
            return (dependent?.IDSITCONSUMI === '1')
        }
    }
}
</script>
<style lang="less" scoped>
    .carousel {
        margin: 25px -15px 0 -15px;
        user-select: none;
        .title {
            margin: 0;
            font-weight: normal;
            font-size: 1.5rem;
            padding: 0 0 0 15px;
        }
        .carousel-container {
            overflow: auto hidden;
            white-space: nowrap;
            background: var(--cardBackground);
            margin: 10px 0;
            display: flex;
            flex-direction: row;
            flex-wrap: nowrap;
            align-content: center;
            justify-content: flex-start;
            align-items: flex-start;
            height: 170px;

            .carousel-item {
                position: relative;
                display: inline-block;
                height: 115px;
                min-width: 140px;
                max-width: 140px;
                margin: 20px 15px;
                padding: 5px;
                // border: solid 1px;

                border-radius: 5px;
                border: 1px solid var(--cardBorder);
                background: var(--cardBackground);
                box-shadow: 2px 2px 4px 0px var(--cardBorder);
                transition: all linear .2s;
                &:active{
                    box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.25);
                }

                .carousel-item-dependant {
                  height: inherit;
                  display: flex;
                  flex-direction: column;
                  justify-content: center;
                }

                i, span, h3 {
                    font-weight: normal;
                    white-space: normal;
                    text-align: center;
                    max-width: 100%;
                    display: block;
                    padding: 0;
                    margin: 0;
                }
                h3 {
                    padding: 0 5px;
                    overflow: hidden;
                    display: -webkit-box;
                    -webkit-line-clamp: 2; /** número de linhas que você quer exibir */
                    -webkit-box-orient: vertical;
                    overflow: hidden;
                    text-overflow: ellipsis;
                }
                span {
                    margin: 10px 0;
                    color: var(--iconColor);
                    font-weight: bold;
                }
                i {
                    color: var(--iconColor);
                    font-size: 1.5rem;
                }
                &.add-user {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    color: var(--iconColor);
                    transform: scale(0.5);
                    i {
                        font-size: 3rem;
                    }
                }
            }

            .carousel-item:has(.blocked) {
                background: #DDD;
            }

            .blocked {
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                h3 {
                    margin: 5px 0;
                }
            }
        }
    }
</style>
